import React from 'react';
import './BentoGrid.css';

function BentoGrid({ firstRowSvgs, secondRowSvgs }) {
  // Duplicate the rows for continuous scrolling
  const duplicatedFirstRow = [...firstRowSvgs, ...firstRowSvgs];
  const duplicatedSecondRow = [...secondRowSvgs, ...secondRowSvgs];

  return (
    <div className="container-fluid ">
      {/* First Row - Scrolling Right to Left */}
      <div className="scroll-container-bento">
        <div className="scroll-content scroll-right">
          {duplicatedFirstRow.map((svg, index) => (
            <div key={`first-${index}`} className="scroll-item first-row-item">
              <div className="bento-card">
                <div className="bento-card-body">
                  <div className="svg-container">{svg}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row - Scrolling Left to Right */}
      <div className="scroll-container-bento">
        <div className="scroll-content scroll-left">
          {duplicatedSecondRow.map((svg, index) => (
            <div key={`second-${index}`} className="scroll-item second-row-item">
              <div className="bento-card">
                <div className="bento-card-body">
                  <div className="svg-container">{svg}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BentoGrid;
